import { ExclusionItemGridWebComponent } from './component/ExclusionItemGridWebComponent';
import { WEB_COMPONENT_EXCLUSION_ITEM_GRID } from '../../webcomponents.constants';
/**
 * The exclusions item grid component for displaying the exclusions items added
 * @link https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/1153468618/Global+Exclusions+Page
 */
export { ExclusionItemGridWebComponent };
window.customElements.define(WEB_COMPONENT_EXCLUSION_ITEM_GRID, ExclusionItemGridWebComponent);
